const React = require('react');
const { findDOMNode } = require('react-dom');
const shallowCompare = require('react-addons-shallow-compare');
const IScroll = require('@portal/iscroll/build/iscroll-lite');
const _find = require('../../utils/find.js');
const DynamicClassLI = require('../mui/misc/dynamic-class-hoc.jsx')('li');
const helper = require('../../helper/dish-helper');
const { isFormalMeal } = require('../../helper/common-helper');
const isShowNav = helper.getUrlParam('showNav');
const diningType = helper.getUrlParam('type');
const classnames = require('classnames');
require('./dish-type-scroller.scss');

const getPrevIndexNotFalse = (ary, initIndex) => {
  let prev = initIndex - 1;
  if (prev >= 0) {
    if (ary[prev] !== false) {
      return prev;
    } else {
      return getPrevIndexNotFalse(ary, prev);
    }
  }
  return -1;
};

const getActiveAndPrevIndex = (dishTypes, dishesData, activeDishTypeId, activeDishTypeIdIndex) => {
  let activeIndex = -1;
  let prevIndex = -1;
  let idxCount = 0;

  const newAry = dishTypes.map((dt, index) => {
    const { dishIds, id } = dt;
    if (!dishIds || dishIds.length === 0) {
      return false;
    }
    if (dishIds.length === 1 && _find(dishesData, { id: dishIds[0] }).currRemainTotal === 0) {
      // 中类下面子菜的数量只有一个且售罄的情况下，中类不显示
      return false;
    }
    if (`${activeDishTypeId}_${activeDishTypeIdIndex}` === `${id}_${idxCount}`) {
      activeIndex = index;
    }
    idxCount++;
    return true;
  });

  if (activeIndex >= 0) {
    prevIndex = getPrevIndexNotFalse(newAry, activeIndex);
  }

  return { activeIndex, prevIndex };
};

module.exports = React.createClass({
  displayName: 'DishTypeScroller',
  propTypes: {
    activeDishTypeId: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    activeDishTypeIdIndex: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    dishTypesData: React.PropTypes.array.isRequired,
    dishesData: React.PropTypes.array.isRequired,
    onDishTypeElementTap: React.PropTypes.func.isRequired,
    theme: React.PropTypes.string,
    diningForm: React.PropTypes.number,
  },
  componentWillMount() {
    this.shouldCalcIscroll = true;
  },
  componentDidMount() {
    const iScrollOptions = this.getIScrollOptionsInDiffTheme();

    this._cache = {};
    this._cache.iScroll = new IScroll('.scroll-wrapper', iScrollOptions);
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.theme === this.props.theme) {
      return;
    }
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  componentDidUpdate() {
    const iScroll = this._cache.iScroll;
    const { theme } = this.props;
    const activeDishType = findDOMNode(this).querySelector('.is-active');
    if (activeDishType) {
      if (/big|huge/.test(theme)) {
        iScroll.scrollToElement(activeDishType, 400, true);
      } else {
        iScroll.scrollToElement(activeDishType, 600, 0, -100);
      }
    }
    // this.initWrapSize();
    setTimeout(() => {
      iScroll.refresh();
    }, 500);
  },
  componentWillUnmount() {
    this._cache.iScroll.destroy();
    this._cache = null;
  },
  onDishTypeElementTap(evt) {
    const { onDishTypeElementTap } = this.props;
    const dishTypeId = evt.currentTarget.dataset.id;
    this.setState({
      dishTypeIdFollow: dishTypeId.split('_')[1],
    });
    onDishTypeElementTap(evt, dishTypeId.split('_')[0], dishTypeId.split('_')[1]);
  },
  getIScrollOptionsInDiffTheme() {
    const defaultOptions = {
      click: true,
      tap: true,
      scrollX: true,
    };

    const getOptions = {
      big() {
        return { scrollX: true, scrollY: false };
      },
      huge() {
        return { scrollX: true, scrollY: false };
      },
    }[this.props.theme];

    const options = getOptions && getOptions.call(this);
    return Object.assign({}, defaultOptions, options);
  },
  initWrapSize() {
    const { dishTypesData, theme } = this.props;
    if (!dishTypesData.length || this._initWrapSized) {
      return;
    }

    const wrapEl = findDOMNode(this).querySelector('.scroll-wrapper');
    const listEl = wrapEl.querySelector('.dish-type-list');
    const rect = listEl.getBoundingClientRect();

    const _init = function _init() {
      if (!/big|huge/.test(theme)) {
        return;
      }
      wrapEl.style.width = `${rect.width + 10}px`;
    };

    _init();
    this._initWrapSized = true;
  },
  buildDishTypeIcon(dishTypeData) {
    if (dishTypeData.type !== 'tag') {
      return false;
    }
    let iconElement = '';
    switch (dishTypeData.name) {
      case '热门':
        iconElement = <i className="icon icon-fire"></i>;
        break;
      case '推荐':
        iconElement = <i className="icon icon-thumb"></i>;
        break;
      case '折扣':
        iconElement = <i className="icon icon-percent"></i>;
        break;
      case '赠品':
        iconElement = <i className="icon icon-present"></i>;
        break;
      case '特价':
        iconElement = <i className="icon icon-tag"></i>;
        break;
      case '特色':
        iconElement = <i className="icon icon-star"></i>;
        break;
      default:
        break;
    }
    return iconElement;
  },
  buildDishTypeElements(activeDishTypeId, activeDishTypeIdIndex, dishTypesData, dishesData) {
    const getOrderedCountByType = (dishes, dishTypeData) => {
      const orderedDishesByType = helper.getOrderedDishes(dishes).filter(dish => dish.dishTypeId === dishTypeData.id);

      let count = helper.getDishesCount(orderedDishesByType);

      return count || null;
    };
    const { diningForm, theme } = this.props;
    const hasFloatingNav = (isFormalMeal(diningForm) && diningType === 'TS') || isShowNav;
    const dishTypeListStyle = theme === 'default' || theme === 'tea' ? { paddingBottom: hasFloatingNav ? 250 : 230 } : {};

    const { activeIndex, prevIndex } = getActiveAndPrevIndex(dishTypesData, dishesData, activeDishTypeId, activeDishTypeIdIndex);

    let idxCount = 0;
    const dishTypeEl = dishTypesData.map((dishTypeData, idx) => {
      if (!dishTypeData.dishIds || dishTypeData.dishIds.length === 0) {
        return false;
      }
      if (dishTypeData.dishIds.length === 1 && _find(dishesData, { id: dishTypeData.dishIds[0] }).currRemainTotal === 0) {
        // 中类下面子菜的数量只有一个且售罄的情况下，中类不显示
        return false;
      }

      // 设置标签图标
      const dishTypeIcon = this.buildDishTypeIcon(dishTypeData);
      const count = getOrderedCountByType(dishesData, dishTypeData);
      let countStyle;
      if (count < 10) {
        countStyle = { width: '16px' };
      } else if (count >= 10 && count <= 99) {
        countStyle = { width: '21px' };
      } else {
        countStyle = { width: '27px' };
      }
      // const isActive = `${activeDishTypeId}_${activeDishTypeIdIndex}` === `${dishTypeData.id}_${idxCount}`;
      // if (isActive) {
      //   activeIndex = idx;
      // }
      const dynamicClassLI = (
        <DynamicClassLI
          key={idx}
          data-id={`${dishTypeData.id}_${idxCount}`}
          data-count={count}
          isActive={activeIndex === idx}
          className={classnames('dish-type-item', { 'dish-type-item--omitAfter': !count }, { 'dish-type-item-prev': prevIndex === idx })}
          onTouchTap={this.onDishTypeElementTap}
        >
          {count > 0 && (
            <i className="dish-type-item--count counter-special" style={countStyle}>
              {count > 99 ? '99+' : count}
            </i>
          )}
          {dishTypeIcon}
          <span>{dishTypeData.name}</span>
        </DynamicClassLI>
      );
      idxCount++;
      return dynamicClassLI;
    });

    return (
      <ul className="dish-type-list" style={dishTypeListStyle}>
        {dishTypeEl}
      </ul>
    );
  },
  render() {
    const { activeDishTypeId, activeDishTypeIdIndex, dishTypesData, dishesData, theme } = this.props;
    const dishTypeElements = this.buildDishTypeElements(activeDishTypeId, activeDishTypeIdIndex, dishTypesData, dishesData);
    const scrollWrapperStyle = theme === 'default' || theme === 'tea' ? { height: '100%' } : {};

    return (
      <div
        className="dish-type-scroller"
        style={{ borderBottom: 'solid 1px #f1f1f1' }}
      >
        <div className="scroll-wrapper" style={scrollWrapperStyle}>
          {dishTypeElements}
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/dish-type-scroller.jsx